import { z } from 'zod';
import { ASPECT_RATIO } from '../types/common.js';
import { PROVIDER_MODALITY } from '../types/prompt.js';

/**
 * ProviderCapability — PRD §30. Diisi manual (MVP) atau hasil probe (§16.1, Fase 5+).
 * `parameterSchema` disimpan sebagai JSON bebas (bentuknya beda-beda per provider),
 * makanya cuma divalidasi sebagai "object apapun", bukan shape spesifik.
 */
export const providerCapabilitySchema = z.object({
  id: z.string().min(1),
  provider: z.string().min(1),
  model: z.string().min(1),
  modality: z.enum(PROVIDER_MODALITY),
  maxPromptLength: z.number().int().positive().nullable().optional(),
  supportsImageInput: z.boolean().default(false),
  supportsReferenceImage: z.boolean().default(false),
  supportsVideo: z.boolean().default(false),
  supportsAudio: z.boolean().default(false),
  supportsNegativePrompt: z.boolean().default(false),
  supportedRatios: z.array(z.enum(ASPECT_RATIO)).default([]),
  supportedDurations: z.array(z.number().int().positive()).default([]),
  parameterSchema: z.record(z.unknown()).nullable().optional(),
  probedAt: z.string().nullable().optional(),
  createdAt: z.string(),
});
export type ProviderCapability = z.infer<typeof providerCapabilitySchema>;

export const registerProviderCapabilityInputSchema = providerCapabilitySchema.omit({
  id: true,
  createdAt: true,
});
export type RegisterProviderCapabilityInput = z.infer<typeof registerProviderCapabilityInputSchema>;
